import * as D from 'io-ts/lib/Decoder'
import { enum_ } from 'decode/util'

export enum VideoStatus {
    UNKNOWN = 'unknown',
    ACTIVE = 'active',
    IDLE = 'idle',
    ERROR = 'error',
    STREAMING = 'streaming',
}

export const VideoDecoder = D.type({
    status: enum_(VideoStatus.UNKNOWN, VideoStatus.STREAMING, VideoStatus.ACTIVE, VideoStatus.IDLE, VideoStatus.ERROR),
    updatedAt: D.string,
})

export interface Video extends D.TypeOf<typeof VideoDecoder> {}
